import React, { useEffect, useState } from "react";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import io from "socket.io-client";
import { useSelector } from "react-redux";
import _ from 'lodash';
import { urls } from '../../Utils/url';
import Up from '@material-ui/icons/ArrowUpward';
import Down from '@material-ui/icons/ArrowDownward';
export const socket = io("https://node.ashrafigold.com:3000");

const Footer = (props) => {
  const [items, setItems] = useState([]);
  const [news, setnews] = useState([]);
  const [oldPrice, setOldPrice] = useState([]);
  const [status, setStatus] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const isFaNum = useSelector((state) => state.persistedParams.isFaNum);

  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    getPriceTypeFR();
    getNews();
  }, []);



  function findDiff(oldArr, newArr) {
    if (newArr) {
      return newArr.map(item => {
        let temp = oldArr?.find(i => i.id == item.id);
        return {
          ...item,
          diff: temp?.price - item?.price
        }

      })
    } else return oldArr.map(item => { return { ...item, diff: 0 } })
  }


  useEffect(() => {
    socket.on("updateFR", (data) => {
      setItems((prevState) => {
        var updateItems = prevState.filter((obj) => obj.type !== data.type);
        var newItems = updateItems.concat(data);
        newItems.sort(function (a, b) {
          return a.ordering - b.ordering;
        });
        return newItems;
      });
    });
  }, []);

  function getPriceTypeFR() {
    setIsLoading(true);
    ApiCall(
      "GET",
      urls.getFrPrices,
      {},
      "getPriceTypeFR ->",
      token,
      (res) => {
        let data = res?.data;
        if (_.isEmpty(data)) return
        setItems(data);
        setIsLoading(false);
      },
      (err) => {
        console.log("getPriceTypeFR Error == ", err);
        setIsLoading(false);
      }
    );
  }

  function getNews() {
    ApiCall(
      "GET",
      urls.getNews,
      {},
      "get news ->",
      token,
      (res) => {
        let data = res?.data;
        if (_.isEmpty(data)) return
        setnews(data);
      },
      (err) => {
        console.log("getPriceTypeFR Error == ", err);
        setIsLoading(false);
      }
    );
  }


  useEffect(() => {
    setInterval(() => {
      getPriceTypeFR();
    }, 5000);
  }, [])


  useEffect(() => {
    setOldPrice(items);
    setStatus(findDiff(oldPrice, items))
  }, [items])

  console.log('footerstatus', status);

  return (
    <div className="screenHome">
      <div className="marquee">
        <div className="_newsSlideContainer">
          <div className="_rowStart">
            {news.map((el, i) => (
              <p key={i} className="_newsText">
                {el.title}
                <span>&#124;</span>
              </p>
            ))}
          </div>
        </div>
      </div>
      {/*FR PRICES TICKER*/}
      <div className="marquee">
        <div className="_priceSlideContainer">
          <div className="_rowStart">
            {status && status.map((item, index) => {
              return (
                <div className='_item' key={item.ordering}>
                  <span className="_label">{item.title}</span>
                  <span className={isFaNum && item.diff === 0 ? "_value_fa" : isFaNum && item.diff > 0 ? "_value_faDown" : isFaNum && item.diff < 0 ? "_value_faUp" : !isFaNum && item.diff === 0 ? "_value_en" : !isFaNum && item.diff > 0 ? "_value_enDown" : "_value_enUp"}>
                    {item.price}
                  </span>
                  <i
                    className={
                      item.diff === 0
                        ? "_footerIcon ion-md-arrow-up" : item.diff > 0 ? "_footerIconDown ion-md-arrow-down"
                          : "_footerIconUp ion-md-arrow-up"
                    }
                  ></i>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
